const simpleSurvey = {
    "title": "評鑑案件申請調查",
    "sections": [
        {
            "subject": "場區環境及建築",
            "description": "說明廠區環境及建築的污染防治措施．",
            "questions": [{
                "description": "廠區外圍是否有污染源？",
                "helperText": "廠區外圍的範圍是指廠區周圍500公尺以內．",
                "type": "scq",
                "options": ["是", "否"]
            },
            {
                "condition": "是",
                "description": "請說明如何防範廠區及產品受到污染",
                "type": "oeq",
                "helperText": "請提供標準作業程序或具體措施.",
                "answer": "塑膠布隔離。"
            }]
        }
    ]
}

export default simpleSurvey;